export const REQUEST_USER_GEOLOCATION_SUCCESS =
  "REQUEST_USER_GEOLOCATION_SUCCESS";
export const REQUEST_USER_GEOLOCATION_FAILED =
  "REQUEST_USER_GEOLOCATION_FAILED";
export const USER_GEOLOCATION_COOKIE = "USER_GEOLOCATION_COOKIE";
export const SET_GEOLOCATION_ADDRESS = "SET_GEOLOCATION_ADDRESS";
export const SET_SEARCHED_LOCATION = "SET_SEARCHED_LOCATION";

import Cookies from "js-cookie";
import { startCase } from "lodash";
import { geocodeCoordinates } from "../../services/googlemaps";

export const fetchUserGeolocation = () => (dispatch) => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  })
    .then(async ({ coords }) => {
      dispatch({
        type: REQUEST_USER_GEOLOCATION_SUCCESS,
        payload: {
          geolocationError: false,
          userLatitude: coords.latitude,
          userLongitude: coords.longitude,
          userSharedLocation: true,
          userDeniedGeolocation: false,
        },
      });

      const address = await geocodeCoordinates(
        coords.latitude,
        coords.longitude
      );
      dispatch(setGeolocationAddress(address));
    })
    .catch((error) => {
      // retains previous latitude/longitude values as fallback
      dispatch({
        type: REQUEST_USER_GEOLOCATION_FAILED,
        payload: {
          geolocationError: true,
          userDeniedGeolocation: true,
        },
      });
    });
};

export const setGeolocationAddress = (address) => {
  return {
    type: SET_GEOLOCATION_ADDRESS,
    payload: {
      address,
    },
  };
};

export const getUserGeolocationCookie = () => (dispatch) => {
  const cookieLatitude = Cookies.get("lll_adobe_geo_latitude") * 1 || null;
  const cookieLongitude = Cookies.get("lll_adobe_geo_longitude") * 1 || null;
  const cookieCity = startCase(Cookies.get("lll_adobe_geo_city") || "");
  const cookieState = startCase(Cookies.get("lll_adobe_geo_state") || "");
  let cookieAddress;
  if (cookieCity && cookieState) {
    cookieAddress = `${cookieCity}, ${cookieState}`;
  } else {
    cookieAddress = `${cookieCity}${cookieState}`;
  }

  dispatch({
    type: USER_GEOLOCATION_COOKIE,
    payload: {
      geolocationError: false,
      userLatitude: cookieLatitude,
      userLongitude: cookieLongitude,
      userSharedLocation: !!cookieLatitude && !!cookieLongitude,
    },
  });

  if (cookieLatitude && cookieLongitude) {
    dispatch(setGeolocationAddress(cookieAddress));
  }
};

export const setSearchedLocation = (lat, long, address) => {
  return {
    type: SET_SEARCHED_LOCATION,
    payload: {
      searchUserLatitude: lat,
      searchUserLongitude: long,
      searchUserAddress: address,
    },
  };
};
